<template>
  <v-card-text>
    <slot />
  </v-card-text>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "CardDescription",
  props: ["title", "color"],
  data() {
    return {};
  },
});
</script>
